import moment from 'moment-timezone'
import {
  NANOSECONDS_TO_MILLISECONDS,
  DATETIME_STATS_DISPLAY_FORMAT,
  DATETIME_STATS_ARGS_FORMAT,
  DATE_RANGE_CHOICES,
  INSIGHTS_DATE_RANGE_CHOICES
} from '@/constants/datetime.constants'

export function dwellTimeFormat (
  timeInMsec,
  {
    years = { enabled: true, unit: 'years' },
    months = { enabled: true, unit: 'mnths' },
    days = { enabled: true, unit: 'days' },
    hours = { enabled: true, unit: 'hours' },
    minutes = { enabled: true, unit: 'mins' },
    seconds = { enabled: true, unit: 'secs' }
  } = {}
) {
  let durationObj = moment.duration(timeInMsec)
  let inYrs = ''

  let inMnths = ''

  let inDays = ''

  let inHrs = ''

  let inMins = ''

  let inSecs = ''
  if (years.enabled && durationObj.years() !== 0) {
    inYrs = `${Math.abs(durationObj.years())}${years.unit}`
  }
  if (months.enabled && durationObj.months() !== 0) {
    inMnths = `${Math.abs(durationObj.months())}${months.unit}`
  }
  if (days.enabled && durationObj.days() !== 0) {
    inDays = `${Math.abs(durationObj.days())}${days.unit}`
  }
  if (hours.enabled && durationObj.hours() !== 0) {
    inHrs = `${Math.abs(durationObj.hours())}${hours.unit}`
  }
  if (minutes.enabled && durationObj.minutes() !== 0) {
    inMins = `${Math.abs(durationObj.minutes())}${minutes.unit}`
  }
  if (seconds.enabled && durationObj.seconds() !== 0) {
    inSecs = `${Math.abs(durationObj.seconds())}${seconds.unit}`
  }

  let resultantTime = ''
  if (inYrs) {
    resultantTime = resultantTime.concat(`${inYrs} `)
  }
  if (inMnths) {
    resultantTime = resultantTime.concat(`${inMnths} `)
  }
  if (inDays) {
    resultantTime = resultantTime.concat(`${inDays} `)
  }
  if (inHrs) {
    resultantTime = resultantTime.concat(`${inHrs} `)
  }
  if (inMins) {
    resultantTime = resultantTime.concat(`${inMins} `)
  }
  if (inSecs) {
    resultantTime = resultantTime.concat(`${inSecs} `)
  }

  return resultantTime.trim()
}

/**
 * ToString format of datetime in user friendly labels.
 *
 * @param {*} timeInMsec
 * @param {*} param1
 */
export function formatTimeDistance (
  startTimeInMsec,
  endTimeInMsec,
  {
    years = { enabled: true, unit: 'years' },
    months = { enabled: true, unit: 'mnths' },
    days = { enabled: true, unit: 'days' },
    hours = { enabled: true, unit: 'hours' },
    minutes = { enabled: true, unit: 'mins' },
    seconds = { enabled: true, unit: 'secs' }
  } = {}
) {
  let timeDist = moment(startTimeInMsec).diff(moment(endTimeInMsec), 'milliseconds')
  return dwellTimeFormat(timeDist, { years, months, days, hours, minutes, seconds })
}

/**
 * ToString format of datetime in user friendly labels.
 *
 * @param {*} timeInMsec
 * @param {*} param1
 */
export function formatFromNow (
  timeInMsec,
  {
    years = { enabled: true, unit: 'years' },
    months = { enabled: true, unit: 'mnths' },
    days = { enabled: true, unit: 'days' },
    hours = { enabled: true, unit: 'hours' },
    minutes = { enabled: true, unit: 'mins' },
    seconds = { enabled: true, unit: 'secs' }
  } = {}
) {
  let fromNowDiff = moment(timeInMsec).diff(moment(), 'milliseconds')
  return dwellTimeFormat(fromNowDiff, { years, months, days, hours, minutes, seconds })
}

/**
 * Format datetime in user friendly labels with only largest value.
 *
 * @param {*} timeInMsec
 * @param {*} param1 string format for time period
 */
export function formatFromNowMaxDist (
  timeInMsec,
  { years = 'y', months = 'M', days = 'd', hours = 'h', minutes = 'm', seconds = 's' } = {}
) {
  let fromNowDiff = moment(timeInMsec).diff(moment(), 'milliseconds')
  let durationObj = moment.duration(fromNowDiff)

  if (durationObj.years() !== 0) {
    return `${Math.abs(durationObj.years())}${years}`.trim()
  }
  if (durationObj.months() !== 0) {
    return `${Math.abs(durationObj.months())}${months}`.trim()
  }
  if (durationObj.days() !== 0) {
    return `${Math.abs(durationObj.days())}${days}`.trim()
  }
  if (durationObj.hours() !== 0) {
    return `${Math.abs(durationObj.hours())}${hours}`.trim()
  }
  if (durationObj.minutes() !== 0) {
    return `${Math.abs(durationObj.minutes())}${minutes}`.trim()
  }

  return `${Math.abs(durationObj.seconds())}${seconds}`.trim()
}

/**
 *
 * Date time sort compare function.
 * Convert comparator a and b to momenttime then use valueof (in ms) for > or < sort.
 *
 * @param {*} a
 * @param {*} b
 */
export function dateTimeSort (a, b) {
  if (!moment(a).isValid()) {
    a = a * NANOSECONDS_TO_MILLISECONDS
  }
  if (!moment(b).isValid()) {
    b = b * NANOSECONDS_TO_MILLISECONDS
  }
  if (!(a instanceof Date)) {
    a = moment(a)
  }
  if (!(b instanceof Date)) {
    b = moment(b)
  }
  a = moment(a).valueOf()
  b = moment(b).valueOf()
  return a === b ? 0 : a < b ? -1 : 1
}

export function lastNthDays (numOfDays = undefined) {
  let daysBucket = []
  if (_.isUndefined(numOfDays)) {
    numOfDays = 7
  }
  for (let daysAgo = 0; daysAgo < numOfDays; daysAgo++) {
    let aDate = moment().subtract(daysAgo, 'days')
    daysBucket.push({
      label: aDate.format(DATETIME_STATS_DISPLAY_FORMAT),
      value: aDate.format(DATETIME_STATS_ARGS_FORMAT)
    })
  }
  return daysBucket
}

export function getDateRangeChoice (value) {
  if (_.isEmpty(value)) {
    return DATE_RANGE_CHOICES[0]
  }
  let dateChoice = _.find(DATE_RANGE_CHOICES, { value: value })
  if (dateChoice) {
    return dateChoice
  }
  return DATE_RANGE_CHOICES[0]
}

export function getInsightsDateRangeChoice (value) {
  if (_.isEmpty(value)) {
    return INSIGHTS_DATE_RANGE_CHOICES[0]
  }
  let dateChoice = _.find(INSIGHTS_DATE_RANGE_CHOICES, { value: value })
  if (dateChoice) {
    return dateChoice
  }
  return INSIGHTS_DATE_RANGE_CHOICES[0]
}

export function getInsightsDateTimeRange (value) {
  const end = new Date()
  const start = new Date()
  if (_.isEmpty(value)) {
    start.setTime(start.getTime() - 3600 * 1000 * 24)
    return [start, end]
  }
  switch (value) {
    case 'PAST_1_HOURS':
      start.setTime(start.getTime() - 3600 * 1000 * 1)
      break
    case 'PAST_2_HOURS':
      start.setTime(start.getTime() - 3600 * 1000 * 2)
      break
    case 'PAST_4_HOURS':
      start.setTime(start.getTime() - 3600 * 1000 * 4)
      break
    case 'PAST_24_HOURS':
      start.setTime(start.getTime() - 3600 * 1000 * 24)
      break
    case 'PAST_48_HOURS':
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
      break
    case 'PAST_72_HOURS':
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
      break
    case 'PAST_1_WEEK':
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      break
    case 'PAST_1_MONTH':
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      break
  }
  return [start, end]
}

export function minutesToMilliseconds (epochMins) {
  return epochMins * 1000 * 60
}

export function getTimestampAgeSeconds (timestamp) {
  let now = new Date().getTime()
  let stamp = timestamp * NANOSECONDS_TO_MILLISECONDS
  return (now - stamp) / 1000
}

export function getHoursSinceMidnight () {
  // Your moment at midnight
  let mmtMidnight = moment().startOf('day')
  // Difference in hours
  return moment().diff(mmtMidnight, 'hours')
}

/**
 * Helper to get start and end timestamp since midnight
 *
 */
export function getTimeSinceMidnight () {
  const startTimeIso = new Date(new Date().setHours(0, 0, 0, 0)).toISOString()
  const endTimeIso = new Date(Date.now()).toISOString()
  return {
    starttime: startTimeIso,
    endtime: endTimeIso
  }
}

/**
 * Helper to get user friendly run time text.
 *
 */
export function getRuntimeText (runtime) {
  if (runtime.includes('years')) {
    return runtime.replace('years', ' years')
  } else if (runtime.includes('mnths')) {
    return runtime.replace('mnths', ' months')
  } else if (runtime.includes('days')) {
    return runtime.replace('days', ' days')
  } else if (runtime.includes('hours')) {
    return runtime.replace('hours', ' hours')
  } else if (runtime.includes('mins')) {
    return runtime.replace('mins', ' mins')
  } else if (runtime.includes('secs')) {
    return runtime.replace('secs', ' secs')
  }
  return runtime
}



// WEBPACK FOOTER //
// ./src/utilities/datetime.helper.js